var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "request-list-select-container" } }, [
    _c(
      "div",
      { staticClass: "form-group-material mb-0" },
      [
        _c("select2", {
          ref: "select",
          attrs: {
            id: "request-list-select",
            data: _vm.requestListsValues,
            value: _vm.selectedRequestList,
            disabled: _vm.disabled,
            name: "request-list-select",
            options: _vm.options,
            "format-data": _vm.formatData,
          },
          on: { change: _vm.handleChange },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "bar" }),
        _vm._v(" "),
        _c("label", { staticClass: "title text-light-gray mb-2 mb-lg-0" }, [
          _vm._v(_vm._s(_vm.$t("documents.selectTemplate"))),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }